/*
 * Copyright (c) 2023. Collabro Limited
 */
import React, { useEffect, useRef, useState } from "react";
import { Collapse, IconButton, InputAdornment, TextField } from "@mui/material";
import BackspaceIcon from "@mui/icons-material/Backspace";
import QuickSearch from "./QuickSearch";

interface QuickSearchCollapseProps {
  quickSearchOpen: HTMLButtonElement | null;
  onClose: any;
}

const QuickSearchCollapse = (props: QuickSearchCollapseProps) => {
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth((containerRef.current as HTMLDivElement).offsetWidth);
    }
  }, []);

  return (
    <div ref={containerRef} style={{ width: "100%" }}>
      <Collapse
        orientation={"horizontal"}
        in={Boolean(props.quickSearchOpen)}
        mountOnEnter
        unmountOnExit
      >
        <QuickSearch containerWidth={containerWidth} variant="filled" />
      </Collapse>
    </div>
  );
};

export default QuickSearchCollapse;
